var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "user-edit" } },
    [
      _c(
        "IForm",
        {
          ref: "formInline",
          attrs: {
            model: _vm.edit,
            elem: _vm.userElem,
            rules: _vm.userRule,
            "label-width": 80,
            submit: false,
            showMessage: true,
          },
          on: { "on-submit": _vm.toSubmit },
        },
        [
          _c(
            "div",
            { attrs: { slot: "extend" }, slot: "extend" },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "用户名", prop: "name" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入用户名",
                              maxlength: "50",
                              disabled: _vm.edit.id ? true : false,
                            },
                            model: {
                              value: _vm.edit.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "name", $$v)
                              },
                              expression: "edit.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "真实姓名", prop: "realName" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入真实姓名",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.realName,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "realName", $$v)
                              },
                              expression: "edit.realName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "角色", prop: "roleId" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择角色",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.edit.roleId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "roleId", $$v)
                                },
                                expression: "edit.roleId",
                              },
                            },
                            _vm._l(_vm.roles, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                staticStyle: { width: "100%" },
                                attrs: { value: item.value, label: item.label },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "密码",
                            prop: "password",
                            required: !this.edit.id,
                          },
                        },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入密码",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "password", $$v)
                              },
                              expression: "edit.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "联系方式", prop: "phone" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入联系方式",
                              maxlength: "15",
                            },
                            model: {
                              value: _vm.edit.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "phone", $$v)
                              },
                              expression: "edit.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "账号类型", prop: "accountType" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.accountType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "accountType", $$v)
                                },
                                expression: "edit.accountType",
                              },
                            },
                            _vm._l(_vm.accountTypeList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "微信登录", prop: "weixinLogin" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.weixinLogin,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "weixinLogin", $$v)
                                },
                                expression: "edit.weixinLogin",
                              },
                            },
                            _vm._l(_vm.weixinLoginList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "备注" } },
                        [
                          _c("Input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入备注",
                              maxlength: "50",
                            },
                            model: {
                              value: _vm.edit.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.edit, "remark", $$v)
                              },
                              expression: "edit.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.edit.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.edit, "status", $$v)
                                },
                                expression: "edit.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }